import { useState, useEffect, useCallback, useRef } from "react";
import PropTypes from "prop-types";

import { Tabs } from "./tabs";
import { EditorialPanel, ArticlePanel } from "./panels";

export function ContentContainer({ data, inView }) {
  const { editorial, meta, title } = data;

  const [activeIndex, setActiveIndex] = useState(0);
  const [items, setItems] = useState([{ label: "About" }]);
  const [isLongEditorialVisible, setIsLongEditorialVisible] = useState(false);
  const [relatedArticles, setRelatedArticles] = useState([]);
  const hasQueried = useRef(false);

  const fetchRelatedArticles = useCallback(async () => {
    const promise = await fetch("/api/itineraries/relatedArticles", {
      method: "POST",
      body: JSON.stringify({
        slug: meta.parent.slug,
        tags: meta.tags?.map(tag => tag.slug) || [],
      }),
    });

    if (!promise.ok) {
      return;
    }

    const { articles } = await promise.json();
    if (articles.items.length) {
      setRelatedArticles(articles.items);
      setItems([...items, { label: "Related content" }]);
    }
  }, [meta, items]);

  useEffect(() => {
    if (inView && !hasQueried.current) {
      fetchRelatedArticles();
      hasQueried.current = true;
    }
  }, [inView, fetchRelatedArticles]);

  const panels = [
    <EditorialPanel
      html={editorial}
      isLongEditorialVisible={isLongEditorialVisible}
      setIsLongEditorialVisible={setIsLongEditorialVisible}
    />,
    <ArticlePanel articles={relatedArticles} className="-mx-8 sm:-mx-10" />,
  ];

  return (
    <div>
      <div>
        <Tabs
          items={items}
          activeIndex={activeIndex}
          handleSelect={i => setActiveIndex(i)}
          poiTitle={title}
        />
      </div>

      <div className="pt-4 border-t border-black-200 md:pt-10">
        {panels[activeIndex]}
      </div>
    </div>
  );
}

ContentContainer.propTypes = {
  inView: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    meta: PropTypes.shape({
      parent: PropTypes.shape({
        slug: PropTypes.string,
      }),
      tags: PropTypes.arrayOf(PropTypes.shape({ slug: PropTypes.string })),
    }).isRequired,
    editorial: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
};
